import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FieldItem from './FieldItem';

interface ContactInfoSectionProps {
  isEditing: boolean;
  profileData: any;
  onEditField: (field: string) => void;
  user: any;
}

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  isEditing,
  profileData,
  onEditField,
  user,
}) => {
  return (
    <View style={localStyles.sectionCard}>
      <Text style={localStyles.sectionTitle}>Contact information</Text>
      <Text style={localStyles.sectionHint}>Tap a row to update. Your email and phone can show a verified badge after confirmation.</Text>
      <View style={localStyles.infoGrid}>
        <FieldItem
          label="First Name"
          value={profileData.firstName}
          iconName="account"
          isEditing={isEditing}
          onPress={() => onEditField('firstName')}
        />

        <FieldItem
          label="Last Name"
          value={profileData.lastName}
          iconName="account"
          isEditing={isEditing}
          onPress={() => onEditField('lastName')}
        />

        <FieldItem
          label="Email"
          value={profileData.email}
          iconName="email"
          isEditing={isEditing}
          onPress={() => onEditField('email')}
          verified={!!user?.emailVerified}
        />

        <FieldItem
          label="Phone"
          value={profileData.phone}
          iconName="phone"
          isEditing={isEditing}
          onPress={() => onEditField('phone')}
          verified={!!user?.phoneVerified}
        >
          <View style={localStyles.fieldContent}>
            <Text style={localStyles.displayText}>{profileData.phone || 'Not provided'}</Text>
          </View>
          {!profileData.phone && isEditing && (
            <Text style={{ fontSize: 12, color: '#666', marginTop: 8, fontStyle: 'italic' }}>
              Add a phone number to verify it automatically
            </Text>
          )}
        </FieldItem>

        {/* Address moved to AddressSection */}
      </View>
    </View>
  );
};

export default ContactInfoSection;

const localStyles = StyleSheet.create({
  sectionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    padding: 24,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: '#F1F5F9',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.03,
    shadowRadius: 10,
    elevation: 3,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: '800',
    color: '#1E293B',
    marginBottom: 8,
    letterSpacing: -0.5,
  },
  sectionHint: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 20,
    lineHeight: 20,
  },
  infoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: 12,
  },
  glassOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fieldContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
  },
  displayText: {
    fontSize: 15,
    fontWeight: '500',
    color: '#1E293B',
    paddingVertical: 4,
  },
});


